import { addDays, addMonths, format, startOfWeek } from 'date-fns';
import { enGB, uk, es, ru, nl, fr, de, it, pl, pt, ro, tr } from 'date-fns/locale';
import { toZonedTime } from 'date-fns-tz';
import type { Lang } from '../contexts/locale.context';
import type { QrLang } from '../contexts/qrLocale.context';
import {
  getMadrid2DaysTimeRange,
  getMadrid2WeeksTimeRange,
  getMadridDayTimeRangeNow,
  getMadridMonthTimeRange,
  getMadridWeekTimeRange,
} from './dates/madrid';

export const dateLocaleMap = {
  uk,
  en: enGB,
  es,
  ru,
  nl,
  fr,
  de,
  it,
  pl,
  pt,
  ro,
  tr,
};

/** Повна доба за календарем Europe/Madrid, що містить момент `time` (мс). */
export const getDayTimeRange = (time: number = Date.now()): [number, number] => getMadridDayTimeRangeNow(time);

/** Вчора — сьогодні (Мадрид) відносно моменту `time`. */
export const get2DaysTimeRange = (time: number = Date.now()): [number, number] => getMadrid2DaysTimeRange(time);

/** Поточний місяць (Мадрид). */
export const getMonthTimeRange = (): [number, number] => getMadridMonthTimeRange(Date.now());

/** Поточний тиждень пн–нд (Мадрид). */
export const getWeekTimeRange = (): [number, number] => getMadridWeekTimeRange(Date.now());

/** Два тижні в межах Мадрида (`lang` лишається для сумісності API; підписи днів — у `getWeekDayLabels`). */
export const get2WeeksTimeRange = (_lang: Lang): [number, number] => getMadrid2WeeksTimeRange(Date.now());

/** Короткі підписи днів тижня для поточного тижня (пн → нд) за календарем Мадрида. */
export const getWeekDayLabels = (lang: Lang | QrLang) => {
  const res: string[] = [];
  let date = startOfWeek(toZonedTime(new Date(), 'Europe/Madrid'), { weekStartsOn: 1 });
  for (let i = 0; i < 7; i++) {
    res.push(format(date, 'EEEEEE', { locale: dateLocaleMap[lang] }));
    date = addDays(date, 1);
  }
  return res;
};

/** Дата для TTL-поля: 3 місяці від `from` (за замовчуванням зараз). */
export const getLogExpireAt = (from: Date | number = Date.now()): Date => addMonths(new Date(from), 3);
